"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineRegionId = void 0;
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderLineRegionId = (item) => {
    if (!item.versions)
        return null;
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
    if (!latest_version)
        return null;
    switch (item.type) {
        case "GOLF": {
            const config = latest_version.config;
            return config?.where_when_who?.region_id;
        }
        case "HOTEL": {
            const config = latest_version.config;
            return config?.where_when_who?.region_id;
        }
        case "TRANSFER": {
            const config = latest_version.config;
            return config?.where_when_who?.region_id;
        }
        case "EXCURSION": {
            const config = latest_version.config;
            return config?.where_when_who?.region_id;
        }
        case "CUSTOM": {
            const config = latest_version.config;
            return config?.where_when_who?.region_id;
        }
    }
    return null;
};
exports.getOrderLineRegionId = getOrderLineRegionId;
